// Todo: We don't have to use this helper for maps. Please use maps component.
// Todo: This helper will be removed

const languageCode = require('@/constants/languageCode');

class GmapsHelper {
  /* eslint-disable class-methods-use-this */
  constructor() {
    this.apiKey = process.env.NUXT_ENV_GOOGLE_MAPS_API_KEY;
    this.callbackName = 'gmapsCallback';
    this.initialized = process.client && !!window.google;
    this.initPromise = new Promise((resolve, reject) => {
      this.resolveInitPromise = resolve;
      this.rejectInitPromise = reject;
    });
  }

  async init() {
    // If Google Maps already is initialized
    // the `initPromise` should get resolved
    // eventually.
    if (this.initialized) return this.initPromise;

    this.initialized = true;
    // The callback function is called by
    // the Google Maps script if it is
    // successfully loaded.
    window[this.callbackName] = () => this.resolveInitPromise(window.google);

    // We inject a new script tag into
    // the `<head>` of our HTML to load
    // the Google Maps script.
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places,drawing&callback=${this.callbackName}&language=${languageCode.EN}`;
    script.onerror = this.rejectInitPromise;
    document.querySelector('head').appendChild(script);

    return this.initPromise;
  }

  createMap(
    el,
    zoom,
    zoomControl = true,
    mapTypeControl = false,
    mapTypeId = 'roadmap',
  ) {
    return new window.google.maps.Map(el, {
      zoom,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.RIGHT_TOP,
      },
      mapTypeId,
      zoomControl,
      mapTypeControl,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      gestureHandling: 'cooperative',
      styles: [
        { elementType: 'geometry', stylers: [{ color: 'gray' }] },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
        { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
        { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
        { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#DCEDC8' }] },
        { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
        { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
        { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
        { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
        { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
        { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#B3E5FC' }] },
        { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
      ],
    });
  }

  createMarker(
    map,
    location,
    draggable = false,
  ) {
    return new window.google.maps.Marker({
      position: location,
      map,
      draggable,
      icon: {
        anchor: new window.google.maps.Point(0, -16),
        path: `M 0, 0
          m -7, -16
          a 7,7 0 1,0 14,0
          a 7,7 0 1,0 -14,0`,
        fillColor: '#009FD4',
        fillOpacity: 1,
        strokeWeight: 0,
      },
    });
  }
}

module.exports = new GmapsHelper();
